import React, { useEffect } from 'react';
import IconClose from '../../assets/icons/IconClose';
import { useDebtResult } from '../../contexts/DebtContext';
import { LoanData, LoanInstallments } from '../../interfaces/Debt';
import {
  TextBold,
  TextMedium,
  TextRegular,
} from '../../styles/GlobalStyledComponents';
import { pricesHelper } from '../../utils/paymentsHelper';
import { IconCloseWrapper } from '../ClickToCallModal/ClickToCallModalStyledComponents';
import {
  DebtDescriptionSection,
  DebtWrapper,
  DetailTextWrapper,
  Hr,
  LoanInfo,
  ModalContainer,
  ModalHeader,
  PriceText,
  QuotaBodyWrapper,
  QuotaData,
  QuotaInfoDetail,
  QuotaInfoTitle,
  QuotaListContainer,
  QuotaPill,
  QuotaTitleWrapper,
  QuotaWrapper,
  ScrollableQuotaList,
} from './DetailModalStyledComponents';
import dayjs from 'dayjs';
import GAnalyticsService from '../../services/GAnalytics/ganalytics.service';
import IconMoney from '../../assets/icons/IconMoney';
import { MoneyWrapper } from '../CustomerHeader/CustomerHeaderStyledComponents';

interface DetailModalProps {
  close: () => void;
}

export const DetailModal: React.FC<DetailModalProps> = ({ close }) => {
  const { debtResult } = useDebtResult();

  useEffect(() => {
    GAnalyticsService.sendShowDebt();
  }, []);

  return (
    <ModalContainer id="debt-detail-modal">
      <ModalHeader id="debt-detail-header">
        <TextBold fontSize={24} lineHeight={32} id="debt-detail-title">
          Detalle
        </TextBold>
        <IconCloseWrapper onClick={() => close()} id="debt-detail-close-icon">
          <IconClose />
        </IconCloseWrapper>
      </ModalHeader>
      <DetailTextWrapper id="debt-detail-text-wrapper">
        <TextRegular fontSize={14} color="gray1">
          Este es el desglose de información que corresponde a tu deuda
        </TextRegular>
      </DetailTextWrapper>
      <DebtWrapper id="debt-detail-debt-wrapper">
        <MoneyWrapper id="debt-detail-money-wrapper">
          <IconMoney />
        </MoneyWrapper>
        <DebtDescriptionSection id="debt-detail-description-section">
          <TextRegular fontSize={14} color="gray5">
            Pago Pendiente
          </TextRegular>
          <PriceText fontSize={18} lineHeight={24}>
            {debtResult?.amount && pricesHelper(debtResult.amount)}
            <TextRegular fontSize={14} lineHeight={16}>
              &nbsp;€
            </TextRegular>
          </PriceText>
        </DebtDescriptionSection>
      </DebtWrapper>
      <QuotaListContainer>
      {debtResult?.loans.map((loan: LoanData, index) => {
        return (
          <ScrollableQuotaList
            key={index}
            id="debt-detail-scrollable-quota-list"
          >
            {loan.installments.map((installment: LoanInstallments, index) => {
              return (
                <QuotaWrapper id="debt-detail-quota-wrapper" key={index}>
                  <QuotaTitleWrapper id="debt-detail-quota-title-wrapper">
                    <QuotaPill id="debt-detail-quota-pill">
                      <TextBold
                        fontSize={12}
                        color="white"
                        lineHeight={16}
                        id="debt-detail-quota-pill-text"
                      >
                        CUOTA {installment.order}
                      </TextBold>
                    </QuotaPill>
                    <LoanInfo id="debt-detail-loan-info">
                      <TextMedium
                        fontSize={16}
                        lineHeight={22}
                        id="debt-detail-loan-info-text"
                      >
                        Operación:{' '}
                        <TextBold fontSize={16} lineHeight={22}>
                          {' '}
                          {loan.ag_code}
                        </TextBold>
                      </TextMedium>
                    </LoanInfo>
                  </QuotaTitleWrapper>
                  <Hr />
                  <QuotaBodyWrapper id="debt-detail-quota-body-wrapper">
                    <QuotaData id="debt-detail-quota-data">
                      <QuotaInfoTitle fontSize={14} lineHeight={16}>
                        Fecha de vencimiento:{' '}
                      </QuotaInfoTitle>
                      <QuotaInfoDetail
                        fontSize={14}
                        lineHeight={16}
                        fontWeight={800}
                      >
                        {' '}
                        {dayjs(installment.due_date, 'YYYY-MM-DD').format(
                          'DD/MM/YYYY'
                        )}
                      </QuotaInfoDetail>
                    </QuotaData>
                    <QuotaData id="debt-detail-quota-data">
                      <QuotaInfoTitle fontSize={14} lineHeight={16}>
                        Cuota:{' '}
                      </QuotaInfoTitle>
                      <QuotaInfoDetail
                        fontSize={14}
                        lineHeight={16}
                        fontWeight={800}
                      >
                        {' '}
                        {pricesHelper(installment.fee)} €
                      </QuotaInfoDetail>
                    </QuotaData>
                    <QuotaData id="debt-detail-quota-data">
                      <QuotaInfoTitle fontSize={14} lineHeight={16}>
                        Capital:{' '}
                      </QuotaInfoTitle>
                      <QuotaInfoDetail
                        fontSize={14}
                        lineHeight={16}
                        fontWeight={800}
                      >
                        {' '}
                        {pricesHelper(installment.unpaid_principal_fee)} €
                      </QuotaInfoDetail>
                    </QuotaData>
                    <QuotaData id="debt-detail-quota-data">
                      <QuotaInfoTitle fontSize={14} lineHeight={16}>
                        Intereses:{' '}
                      </QuotaInfoTitle>
                      <QuotaInfoDetail
                        fontSize={14}
                        lineHeight={16}
                        fontWeight={800}
                      >
                        {' '}
                        {pricesHelper(installment.interest_fee)} €
                      </QuotaInfoDetail>
                    </QuotaData>
                    <QuotaData id="debt-detail-quota-data">
                      <QuotaInfoTitle fontSize={14} lineHeight={16}>
                        Gastos de devolución:{' '}
                      </QuotaInfoTitle>
                      <QuotaInfoDetail
                        fontSize={14}
                        lineHeight={16}
                        fontWeight={800}
                      >
                        {' '}
                        {pricesHelper(installment.return_expenses)} €
                      </QuotaInfoDetail>
                    </QuotaData>

                    <QuotaData id="debt-detail-quota-data">
                      <QuotaInfoTitle fontSize={14} lineHeight={16}>
                        Intereses de mora:{' '}
                      </QuotaInfoTitle>
                      <QuotaInfoDetail
                        fontSize={14}
                        lineHeight={16}
                        fontWeight={800}
                      >
                        {' '}
                        {pricesHelper(installment.arrears)} €
                      </QuotaInfoDetail>
                    </QuotaData>

                    <QuotaData id="debt-detail-quota-data">
                      <QuotaInfoTitle fontSize={14} lineHeight={16}>
                        Días a fecha:{' '}
                      </QuotaInfoTitle>
                      <QuotaInfoDetail
                        fontSize={14}
                        lineHeight={16}
                        fontWeight={800}
                      >
                        {' '}
                        {installment.days_past_due}
                      </QuotaInfoDetail>
                    </QuotaData>
                  </QuotaBodyWrapper>
                </QuotaWrapper>
              );
            })}
          </ScrollableQuotaList>
        );
      })}
      </QuotaListContainer>
    </ModalContainer>
  );
};
